import { useGetOfferSelectListLazy } from '@occc-app/dataAccessLayer/offer/queries';

import { OfferItem } from './types';

export const mapOfferQueryResponseToRawArray = (
  response: ReturnType<typeof useGetOfferSelectListLazy>['response'],
): OfferItem[] => response.data ?? [];

export const mapRawOffersResponseItemToAutocompleteOption = (item: OfferItem) => ({
  value: item.id,
  label: item.name,
  _raw: item,
});
